import { Actor } from "../actor.js";
import { Layer } from "../tile.js";
import { actorDB } from "../const.js";
// Weird "good job CC2" tiles
export class VoodooTile extends Actor {
    constructor() {
        super(...arguments);
        this.id = "voodooTile";
        this.tileOffset = this.customData === "" ? null : parseInt(this.customData, 10);
    }
    getLayer() {
        return Layer.STATIONARY;
    }
}
actorDB["voodooTile"] = VoodooTile;
//# sourceMappingURL=weird.js.map